// Componente do formulário de login
import React from "react";
import PasswordInput from "./PasswordInput";
import style from "../signin.module.css";

/**
 * Componente LoginForm - Formulário de login
 * @param {Object} props - Propriedades do componente
 * @param {Object} props.formData - Dados do formulário {user, password}
 * @param {Object} props.errors - Erros de validação por campo
 * @param {boolean} props.showPassword - Se a senha está visível
 * @param {Function} props.onFieldChange - Handler para mudança de campo
 * @param {Function} props.onTogglePassword - Handler para toggle de senha
 * @param {Function} props.onSubmit - Handler de submissão do formulário
 * @param {boolean} props.loading - Se está carregando
 * @returns {JSX.Element} Formulário de login
 */
const LoginForm = ({
  formData,
  errors,
  showPassword,
  onFieldChange,
  onTogglePassword,
  onSubmit,
  loading
}) => {
  return (
    <form onSubmit={onSubmit}>
      {/* Campo de usuário */}
      <div className={style["input-field"]} style={{ marginBottom: "0px" }}>
        <p>
          Usuário <span className={style["required"]}>*</span>
        </p>
        <input
          className={style["inputs-text"]}
          type="text"
          name="user"
          id="user"
          placeholder="usuário"
          value={formData.user}
          onChange={(e) => onFieldChange("user", e.target.value)}
        />
        <div className={style.underline}></div>
      </div>

      {/* Mensagem de erro de validação */}
      {errors.user && (
        <p style={{ display: "block", color: "red", marginTop: "10px" }}>
          {errors.user}
        </p>
      )}

      {/* Campo de senha */}
      <PasswordInput
        value={formData.password}
        onChange={(e) => onFieldChange("password", e.target.value)}
        showPassword={showPassword}
        onToggle={onTogglePassword}
        error={errors.password}
      />

      {/* Botão de login */}
      <input
        className={style["button"]}
        type="submit"
        value={loading ? "Entrando..." : "Login"}
        disabled={loading}
      />
    </form>
  );
};

export default LoginForm;

